import React, { useState, useMemo } from 'react';
import { Form } from 'react-bootstrap';
import ChecklistTemplateRow from './ChecklistTemplateRow';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';

const ChecklistTemplateList = ({ rows = [], onUpdate, onDelete, onUpdateOrder }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredRows = useMemo(() => {
    if (!searchTerm) return rows;
    return rows.filter((row) =>
      row.question.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [rows, searchTerm]);

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const reordered = Array.from(filteredRows);
    const [moved] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, moved);

    onUpdateOrder(reordered);
  };

  return (
    <>
      <Form.Control
        type="text"
        placeholder="Search rows..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="mb-3"
      />

      {filteredRows.length === 0 && (
        <p className="text-muted">No rows match your search.</p>
      )}

      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId="checklist-rows-list">
          {(provided) => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
              className="d-flex flex-column gap-3"
            >
              {filteredRows.map((row, index) => (
                <Draggable key={row.id} draggableId={row.id.toString()} index={index}>
                  {(provided) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      <ChecklistTemplateRow
                        row={row}
                        onUpdate={onUpdate}
                        onDelete={onDelete}
                      />
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </>
  );
};

export default ChecklistTemplateList;